<template>
  <div class="page">
    <div class="header" v-if="giftBook">
      <div class="text">
        集满可获得
        <span style="color: #FFE519">
          {{giftBook.exchangeType == 'avatar_frame'? '' : formatPrice(giftBook.exchangeValue) }}
          {{giftBook.exchangeType == 'balance'? '余额' :
            giftBook.exchangeType == 'integral'? '积分' :
                giftBook.exchangeType == 'avatar_frame'? '头像框' : '未知'}}
        </span>
        奖励
      </div>
      <div class="endTime">
        {{formatDate(giftBook.endDate, 'YYYY-MM-DD HH:mm')}}
      </div>
      <div class="scheduleBox">
        <div>礼物收集进度</div>
        <div class="schedule">
          <div class="percent100">
            <div class="percent" :style="'width: ' + (lightUpGiftCount / giftBook.giftCount * 100) + '%'"></div>
          </div>
          <div style="color: rgba(255, 255, 255, 0.7)">{{lightUpGiftCount}}/{{ giftBook.giftCount }}</div>
        </div>
      </div>
      <div class="acquireBtn" :class="isCollectedSuccess && !isReceiveAward? 'active' : ''" @click="acquireBtn">{{!isReceiveAward? '领取奖励' : '已领取奖励'}}</div>
      <div class="award">
        <img :src="giftBook.exchangeType == 'avatar_frame' ? giftBook.avatarFrameUrl : giftBook.exchangeType == 'integral'? '/static/images/1508/integral.png' : '/static/images/1508/balance.png' " class="awardImg"/>
        <div class="name">{{giftBook.exchangeType == 'avatar_frame'? '' : formatPrice(giftBook.exchangeValue) }}
          {{giftBook.exchangeType == 'balance'? '余额' :
              giftBook.exchangeType == 'integral'? '积分' :
                  giftBook.exchangeType == 'avatar_frame'? '头像框' : ''}}</div>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <img src="/static/images/1508/left.png" class="left"/>
        <div style="margin: 0 6.2vw;">{{ giftBook.name }}</div>
        <img src="/static/images/1508/right.png" class="right"/>
      </div>
      <div class="list">
        <div v-for="(item, index) in list" :key="index" class="listItem">
          <div class="core">
            <div style="width: 75.9%;">
              <div class="square">
                <img :src="item.imgUrl" class="giftImg"/>
              </div>
            </div>
            <div class="name" :style="true? 'color: #fff' : 'color:#6D7188'">{{item.name}}</div>
            <div class="price">
              <img src="/static/images/1508/price-icon.png" style="width: 2.5vw; height: 2.5vw; margin-right: 1px;"/>
              {{formatPrice(item.amount)}}
            </div>
          </div>

          <div class="collectedCount">
            已集齐{{item.collectedCount}} / {{item.needCount}}
          </div>
        </div>
      </div>
      <surprised v-model="surprisedShow" :awardsText="surprised.awardsText" :iconUrl="surprised.iconUrl" @close="surprisedShow = false"></surprised>
    </div>
  </div>
</template>

<script>
import Decimal from "decimal.js";
import surprised from "@/views/1508/surprised"
import {Dialog, Toast} from "vant";
import { getDetail, receiveAward } from "@/api/1508/honor";
import moment from "moment";


export default {
  name: "gainHonor",

  components:{
    surprised
  },

  data(){
    return{
      surprisedShow: false,
      list: [],
      id: this.$route.query.id,
      giftBook: [],
      lightUpGiftCount: null,
      isReceiveAward: null,
      isCollectedSuccess: null,
      surprised: {
        awardsText: '',
        iconUrl: '',
      }
    }
  },

  methods:{
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },

    acquireBtn(){
      if(!this.isCollectedSuccess || this.isReceiveAward){
        return
      }
      this.receiveAward()
    },

    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },

    receiveAward(){ //领取奖励
      Toast.loading({
        mask: true,
        message: '请稍候...',
        duration: 0
      })
      receiveAward({
        giftBookId: this.giftBook.id
      }).then(res=>{
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          let amount = this.giftBook.exchangeType == 'avatar_frame'? '' : this.formatPrice(this.giftBook.exchangeValue)
          let type = this.giftBook.exchangeType == 'balance'? '余额' : this.giftBook.exchangeType == 'integral'? '积分' : this.giftBook.exchangeType == 'avatar_frame'? '头像框' : ''
          this.surprised.awardsText = amount + type
          if( this.giftBook.exchangeType == 'avatar_frame'){
            this.surprised.iconUrl = this.giftBook.avatarFrameUrl
          }else if(this.giftBook.exchangeType == 'integral'){
            this.surprised.iconUrl = "/static/images/1508/integral.png"
          }else if(this.giftBook.exchangeType == 'balance'){
            this.surprised.iconUrl = "/static/images/1508/balance.png"
          }
          this.surprisedShow = true
          this.getDetail()
        } else {
          Dialog.alert({
            title: '领取失败',
            message: data.msg
          })
        }
      })
    },

    getDetail(){
      getDetail({
        giftBookId: this.id
      }).then(res=>{
        const data = res.data;
        if (data.code == 0) {
          this.list = data.giftList
          this.giftBook = data.giftBook
          this.lightUpGiftCount = data.lightUpGiftCount
          this.isReceiveAward = data.isReceiveAward
          this.isCollectedSuccess = data.isCollectedSuccess
        } else {
          Dialog.alert({
            title: '获取失败',
            message: data.msg
          })
        }
      })
    },
  },

  activated() {
    this.getDetail()
  },

  mounted() {
  }
}
</script>

<style scoped lang="less">
.page{
  height: 100vh;
  padding-top: 22.5vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  &:after{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background: url("/static/images/1508/honorBg2.png");
    background-size: 100%;
    background-repeat: no-repeat;
    z-index: -1;
  }

  &:before{
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background: #20203C;
    background-size: 100%;
    background-repeat: no-repeat;
    z-index: -1;
  }

  .header{
    color: #fff;
    padding: 0 35vw 0 10.2vw;
    position: relative;

    .text{
      font-size: 3.5vw;
      line-height: 1;
      margin-bottom: 1.8vw;
    }

    .endTime{
      color: rgba(255, 255, 255, .3);
      font-size: 2.7vw;
      margin-bottom: 3.7vw;
      height: 2.7vw;
      line-height: 2.7vw;
    }

    .scheduleBox{
      font-size: 2.7vw;
      line-height: 1;
      margin-bottom: 3.6vw;

      .schedule{
        display: flex;
        align-items: center;
        margin-top: 1.7vw;

        .percent100{
          flex: 1;
          height: 2.6vw;
          background: rgba(255, 255, 255, .1);
          border-radius: 222px;
          margin-right: 1.3vw;

          .percent{
            height: 100%;
            border-radius: 222px;
            background: linear-gradient(90deg, #526DFD, #46ACFB);
            overflow: hidden;
            position: relative;

            &:after{
              content: '';
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              width: 100%;
              background: url("/static/images/1508/tiaoxing.png") repeat-x;
              background-size: 50vw;
              background-position-x: -4vw;

            }
          }
        }
      }
    }

    .acquireBtn{
      background: rgba(255, 255, 255, .05);
      color: rgba(255, 255, 255, .3);
      width: 24.4vw;
      height: 8.1vw;
      line-height: 8.1vw;
      text-align: center;
      font-size: 2.7vw;
      border-radius: 222px;

      &.active{
        background: #775DF6;
        color: #fff
      }
    }

    .award{
      position: absolute;
      top: 0vw;
      right: 8.2vw;

      .awardImg{
        width: 23.8vw;
        height: 23.8vw
      }

      .name{
        margin-top: 1.2vw;
        text-align: center;
        color: #FFE519;
        font-size: 2.9vw;
        line-height: 1;
      }
    }
  }

  .content{
    margin-top: 11.85vw;

    .title{
      font-size: 4vw;
      color:#FEF9CF;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 5.65vw;

      .left,
      .right{
        width: 14.8vw;
        height: 4.5vw;
      }
    }

    .list{
      display: flex;
      flex-wrap: wrap;
      padding: 0 5vw 10vw;

      .listItem{
        width: 30.53%;
        margin-right: 4.2%;
        border: 2px solid #17254F;
        box-sizing: border-box;
        border-radius: 3.6vw;
        padding: .9vw;
        margin-bottom: 9.2vw;
        position: relative;

        .core{
          background: linear-gradient(-45deg, #212748, #282E47);
          border-radius: 2.9vw;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: .9vw 0 1.9vw 0;

          .square{
            position: relative;
            padding-bottom: 100%;

            .giftImg{
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            }
          }

          .name{
            font-size: 3.2vw;
            line-height: 1;
            margin-top: .6vw;
          }

          .price{
            margin-top: 1.2vw;
            color: #FFE519;
            display: flex;
            align-items: center;
            font-size: 2.7vw;
            line-height: 1;
          }
        }

        &:nth-child(3n){
          margin-right: 0
        }

        .collectedCount{
          font-size: 2.7vw;
          color: #fff;
          text-align: center;
          position: absolute;
          bottom: -5vw;
          left: 0;
          right: 0;
        }
      }
    }
  }
}
</style>